export class PaginationItemModel {
    public constructor(
        public pageNumber: number,
        public displayName: string,
        public url: string,
        public isCurrent: boolean) {
    }

    public hasUrl(): boolean {
        return this.url.length > 0;
    }

    public getLabel(): string {
        if (!this.hasUrl()) {
            return "";
        }

        if (!!Number(this.displayName)) {
            return `Go to page ${this.pageNumber}`;
        }

        return `Go to ${this.displayName} page`;
    }
}
